import { useTranslation } from 'react-i18next';

export default function WhyChooseUs() {
  const { t } = useTranslation();
  
  const features = [
    {
      icon: 'ri-heart-pulse-line',
      title: t('whyChoose.healthCertified'),
      description: t('whyChoose.healthCertifiedDesc')
    },
    {
      icon: 'ri-parent-line',
      title: t('whyChoose.championBloodlines'),
      description: t('whyChoose.championBloodlinesDesc')
    },
    {
      icon: 'ri-home-heart-line',
      title: t('whyChoose.homeRaised'),
      description: t('whyChoose.homeRaisedDesc')
    },
    {
      icon: 'ri-file-list-3-line',
      title: t('whyChoose.completeDocumentation'),
      description: t('whyChoose.completeDocumentationDesc')
    },
    {
      icon: 'ri-customer-service-2-line',
      title: t('whyChoose.ongoingSupport'),
      description: t('whyChoose.ongoingSupportDesc')
    },
    {
      icon: 'ri-gift-line',
      title: t('whyChoose.puppyStarterKit'),
      description: t('whyChoose.puppyStarterKitDesc')
    }
  ];

  return (
    <section className="py-20 bg-gradient-to-b from-amber-50/30 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {t('whyChoose.title')} <span className="text-amber-600">{t('whyChoose.titleHighlight')}</span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('whyChoose.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="bg-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-amber-100 text-amber-600 rounded-2xl mb-6">
                <i className={`${feature.icon} text-3xl`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-3">{feature.title}</h3>
              <p className="text-gray-600 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-amber-600 to-amber-500 rounded-3xl p-12 text-center text-white">
          <h3 className="text-3xl md:text-4xl font-bold mb-4">
            {t('whyChoose.ctaTitle')}
          </h3>
          <p className="text-xl mb-8 opacity-95">
            {t('whyChoose.ctaSubtitle')}
          </p>
          <button 
            onClick={() => {
              const element = document.getElementById('contact');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-white text-amber-600 px-10 py-4 rounded-full text-lg font-semibold hover:bg-gray-50 transition-all shadow-lg cursor-pointer whitespace-nowrap"
          >
            {t('whyChoose.ctaButton')}
          </button>
        </div>
      </div>
    </section>
  );
}
